import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { withAnalyticsEvents, withAnalyticsContext, createAndFireEvent } from '@atlaskit/analytics-next';
import { name as packageName, version as packageVersion } from '../../package.json';
import TabsNavigation from './TabsNavigation';
import DefaultTabContent from './TabContent';
import DefaultTabItem from './TabItem';
import { Tabs as StyledTabs } from '../styled';


var defaultIsSelectedTestNumber = function defaultIsSelectedTestNumber(selectedIndex, tab, tabIndex) {
  return selectedIndex === tabIndex;
};

var defaultIsSelectedTestObject = function defaultIsSelectedTestObject(selected, tab) {
  return selected === tab;
};

var defaultComponents = {
  Content: DefaultTabContent,
  Item: DefaultTabItem
};

var Tabs = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs(props) {
    _classCallCheck(this, Tabs);

    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || _Object$getPrototypeOf(Tabs)).call(this, props));

    _initialiseProps.call(_this);

    var initiallyselected = _this.props.selected || _this.props.defaultSelected || _this.props.tabs[0];

    var selected = _this.resolveSelected(initiallyselected);

    _this.state = {
      selected: selected
    };
    return _this;
  }

  _createClass(Tabs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof newProps.selected !== 'undefined' && newProps.selected !== this.state.selected) {
        var selected = this.resolveSelected(newProps.selected, newProps);
        this.setState({ selected: selected });
      } else if (newProps.tabs !== this.props.tabs) {
        var updatedselected = this.resolveSelected(this.state.selected, newProps);
        this.setState({ selected: updatedselected });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          components = _props.components,
          tabs = _props.tabs;
      var selected = this.state.selected;

      var _defaultComponents$co = _extends({}, defaultComponents, components),
          Content = _defaultComponents$co.Content,
          Item = _defaultComponents$co.Item;

      var contentProps = {
        data: selected,
        elementProps: {
          role: 'tabpanel'
        }
      };
      return React.createElement(
        StyledTabs,
        null,
        React.createElement(TabsNavigation, {
          component: Item,
          onSelect: this.onSelect,
          selected: selected,
          tabs: tabs
        }),
        React.createElement(Content, contentProps)
      );
    }
  }]);

  return Tabs;
}(Component);

Tabs.defaultProps = {
  components: {}
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.resolveSelected = function (selected, newProps) {
    var _ref = newProps || _this2.props,
        tabs = _ref.tabs,
        isSelectedTest = _ref.isSelectedTest;

    var testFunction = function () {
      if (isSelectedTest) {
        return isSelectedTest;
      }
      if (typeof selected === 'number') {
        return defaultIsSelectedTestNumber;
      }
      return defaultIsSelectedTestObject;
    }();

    return tabs.find(function (tab, tabIndex) {
      return testFunction(selected, tab, tabIndex);
    }) || tabs[0];
  };

  this.onSelect = function (newselected, newSelectedIndex) {
    var _props2 = _this2.props,
        onSelect = _props2.onSelect,
        selected = _props2.selected;

    if (typeof onSelect === 'function') {
      onSelect(newselected, newSelectedIndex);
    }
    if (typeof selected === 'undefined') {
      _this2.setState({ selected: newselected });
    }
  };
};

export { Tabs as TabsWithoutAnalytics };
var createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');

export default withAnalyticsContext({
  componentName: 'tabs',
  packageName: packageName,
  packageVersion: packageVersion
})(withAnalyticsEvents({
  onSelect: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'tab',

    attributes: {
      componentName: 'tabs',
      packageName: packageName,
      packageVersion: packageVersion
    }
  })
})(Tabs));